"use strict";

exports.__esModule = true;
exports.MeasureChartDataProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _AdvancedTimelineQueryController = require("../../Timeline/AdvancedTimelineQueryController");
var _SelectedDevicesController = require("../../Device/SelectedDevicesController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MeasureChartDataProvider = exports.MeasureChartDataProvider = function MeasureChartDataProvider(_ref) {
  var measureChartSeries = _ref.measureChartSeries,
    children = _ref.children,
    interval = _ref.interval;
  var device = (0, _SelectedDevicesController.useSelectedDevices)();
  var timelineName = measureChartSeries[0].dataSourceType;
  return /*#__PURE__*/_react["default"].createElement(_AdvancedTimelineQueryController.AdvancedTimelineQueryController, {
    timelineName: timelineName,
    interval: interval,
    body: {
      entity: {
        device: device
      }
    }
  }, children);
};